import axios from 'axios';
import Account from './helpers/Account';
import Cookies from 'js-cookie'
import { REACT_APP_API_URL } from './config';
import { lang } from "./translate";
const { REACT_APP_SERVER ,REACT_APP_Dev} = process.env

const api = axios.create({
    baseURL: REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') &&  !REACT_APP_Dev? '/rest' : ''),
    'Access-Control-Allow-Origin': REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') &&  !REACT_APP_Dev? '/rest' : '')
});

const urs = axios.create({
    baseURL: REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') &&  !REACT_APP_Dev? '/rest' : ''),
    'Access-Control-Allow-Origin': REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') &&  !REACT_APP_Dev? '/rest' : '')
});

const updateAndCreateApi = axios.create({
    baseURL: REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') &&  !REACT_APP_Dev? '/rest' : ''),
});
const updateAndCreateApiAdmin = axios.create({
    baseURL: REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office')&&  !REACT_APP_Dev ? '/rest' : ''),
});


api.interceptors.request.use(
    (config) => {
        config.headers = {
            Authorization: `Bearer ${Account.getAdminToken()}`,
        };
        return config;
    },
    (error) => Promise.resolve({ error }),
);


urs.interceptors.request.use(
    (config) => {
        config.headers = {
            Authorization: `Bearer ${Account.getUrsToken()}`,
        };
        return config;
    },
    (error) => Promise.resolve({ error }),
);

updateAndCreateApi.interceptors.request.use(
    // eslint-disable-next-line no-unused-vars
    (config) => {
        config.headers = {
            Authorization: `Bearer ${Account.getAdminToken()}`,
            'Content-Type': 'multipart/form-data',
        };
        return config;
    },
    (error) => Promise.resolve({ error }),
);

updateAndCreateApiAdmin.interceptors.request.use(
    // eslint-disable-next-line no-unused-vars
    (config) => {
        config.headers = {
            Authorization: `Bearer ${Account.getUrsToken()}`,
            'Content-Type': 'multipart/form-data',
        };
        return config;
    },
    (error) => Promise.resolve({ error }),
);
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};
let isRefreshing1 = false;
let failedQueue1 = [];

const processQueue1 = (error, token = null) => {
    failedQueue1.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue1 = [];
};

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response.status === 401 && !originalRequest._retry) {
            if (!isRefreshing) {
                isRefreshing = true;

                try {
                    const { data } = await api.post('/users/refresh', { token: Account.getAdminRefreshToken() });

                    Account.setAdminToken(data);
                    isRefreshing = false;
                    processQueue(null, data.accessToken);

                    return api(originalRequest);
                } catch (e) {
                    await Account.logoutAdmin();
                    window.location.pathname = '/login';
                    processQueue(e, null);
                    return Promise.reject(error);
                } finally {
                    isRefreshing = false;
                }
            } else {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then((token) => {
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    return api(originalRequest);
                }).catch((err) => {
                    return Promise.reject(err);
                });
            }
        } else if (error.response.status === 405) {
            if (window.location.pathname !== '/login') {
                (async () => {
                    await Account.logoutAdmin();
                    window.location.pathname = '/login';
                })();
            }
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);
urs.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response.status === 401 && !originalRequest._retry) {
            if (!isRefreshing1) {
                isRefreshing1 = true;

                try {
                    const { data } = await urs.post('/users/refresh_urs', { token: Account.getUrsRefreshToken() });

                    Account.setUrsAdminToken(data);
                    isRefreshing1 = false;
                    processQueue1(null, data.accessToken);

                    return urs(originalRequest);
                } catch (e) {
                    await Account.logoutAdmin();
                    window.location.reload()
                    processQueue1(e, null);
                    return Promise.reject(error);
                } finally {
                    isRefreshing1 = false;
                }
            } else {
                return new Promise((resolve, reject) => {
                    failedQueue1.push({ resolve, reject });
                }).then((token) => {
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    return urs(originalRequest);
                }).catch((err) => {
                    return Promise.reject(err);
                });
            }
        } else if (error.response.status === 405) {
            if (window.location.pathname !== '/admin_login') {
                (async () => {
                    await Account.logoutAdmin();
                    window.location.pathname = '/admin_login';
                })();
            }
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);

class Api {
    //-------SPY--------//
    static apyAdminGet() {
        return api.get(`/spy/admins`,);
    }
    static apyOperatorGet(admin) {
        return api.get(`/spy/operators?admin=${admin}`,);
    }
    static apyOperatorPost(form) {
        return api.post(`/spy/operators?admin=${form.admin}`, { form: form.list });
    }
    static spySip() {
        return api.get(`/spy/sip`,);
    }
    static spyAdminSet(buddy, isspyadmin) {
        return api.patch(`/spy/admin`, { buddy, isspyadmin });
    }

    //-------QR--------//
    static createQR() {
        return api.post(`/qr/create-qr-session`,);
    }
    static checkQR(token) {
        return api.get(`/qr/check-qr-session/${token}`,);
    }

    //-------CRM--------//
    static getCrmConfigs(sip) {
        return api.get(`/crm/configs?id=${sip}`,);
    }
    static crmConfigs(form, sip, id) {
        return api.put(`/crm/configs`, { config: form, sip, id, token: Account.getUrsToken() });
    }
    //-------CALLCENTER--------//

    static callCenterCreate(form) {
        return api.post(`/call_center/create`, { ...form, urs: Account.getUrsToken() });
    }
    static callCenterSipCreate(form) {
        return api.post(`/call_center/crm_create`, { ...form, urs: Account.getUrsToken() });
    }
    static callCenterSipUpdate(form) {
        return api.put(`/call_center/crm_update`, { ...form, urs: Account.getUrsToken() });
    }
    static callCenterSipDelete(form) {
        return api.post(`/call_center/crm_delete`, { ...form, urs: Account.getUrsToken() });
    }
    static getCallCenter(sip) {
        return api.get(`/call_center/get`);
    }
    static callCenterDelete() {
        return api.delete(`/call_center/delete`);
    }
    //-------RETAIL--------//
    static retail_domain(form) {
        return api.post(`/retail/create`, { ...form, urs: Account.getUrsToken() });
    }
    static retailUsers() {
        return api.get(`/retail/users`,);
    }
    static retailCrmCreate(form) {
        return api.post(`/retail/crm_create`, { ...form, token: Account.getUrsToken() });
    }
    static retailCrmDelete(id) {
        return api.post(`/retail/crm_delete?id=${id}`, { token: Account.getUrsToken() });
    }
    static retailDelete() {
        return api.post(`/retail/delete`, { token: Account.getUrsToken() });
    }
    static retailCrmEdit(form) {
        return api.put(`/retail/crm_edit`, { ...form, token: Account.getUrsToken() });
    }
    //--------U-ON-------//
    static uon_domain(form) {
        return api.post(`/u-on/create`, { ...form, urs: Account.getUrsToken() });
    }
    static uonUsers() {
        return api.get(`/u-on/users`,);
    }
    static uonCrmCreate(form) {
        return api.post(`/u-on/crm_create`, { ...form, token: Account.getUrsToken() });
    }
    static uonCrmEdit(form) {
        return api.put(`/u-on/crm_edit`, { ...form, token: Account.getUrsToken() });
    }
    static uonCrmDelete(id) {
        return api.post(`/u-on/crm_delete?id=${id}`, { token: Account.getUrsToken() });
    }
    static uonDelete() {
        return api.post(`/u-on/delete`, { token: Account.getUrsToken() });
    }
    //--------DRAG------//
    static drag() {
        return api.get(`/drag/data`);
    }
    static dragSingle(id, type) {
        return api.get(`/drag/single?id=${id}&type=${type}`);
    }
    static type(type) {
        return api.get(`/drag/type?type=${type}&token=${Account.getUrsToken()}`,);
    }
    static dragCreate(form) {
        return api.post(`/drag/create`, { ...form, token: Account.getUrsToken() });
    }
    static dragCreateSip(form) {
        return api.post(`/drag/create_sip`, { ...form, token: Account.getUrsToken() });
    }
    //-------BITRIX------//
    static audio(file) {
        return api.get(`/history/audio?file=${file}`);
    }
    static bitrix_domain(form) {
        return api.post(`/bitrix24/login?domain=${form}`, { token: Account.getAdminToken(), urs: Account.getUrsToken() });
    }
    static bitrix_delete() {
        return api.post(`/bitrix24/delete`, { urs: Account.getUrsToken() });
    }
    static bitrix_get() {
        return api.get(`/bitrix24/get`,);
    }
    static bitrix_admin() {
        return api.get(`/bitrix24/admin`,);
    }
    static bitrix_create(form) {
        return api.post(`/bitrix24/create`, form);
    }
    static bitrix_edit(form) {
        return api.post(`/bitrix24/edit`, form);
    }
    static bitrix_delete_crm(id) {
        return api.post(`/bitrix24/delete_crm?id=${id}`,);
    }
    static bitrix_lead_types() {
        return api.get(`/bitrix24/lead_types`);
    }
    static bitrix_deal_types() {
        return api.get(`/bitrix24/deal_types`);
    }
    static bitrix_contact_types() {
        return api.get(`/bitrix24/contact_types`);
    }

    //-------ZOHO------//
    static zohoCode(code, location) {
        return api.get(`/zoho/code?code=${code}&location=${location}`);
    }

    static getZohoUsers(page, limit) {
        return api.get(`/zoho/users?page=${page || 10}&per_page=${limit || 50}`);
    }
    static zohoDelete() {
        return api.post(`/zoho/delete`, { token: Account.getUrsToken() });
    }
    static zohoCrmCreate(form) {
        return api.post(`/zoho/crm`, { ...form, token: Account.getUrsToken() });
    }
    static zohoCrmEdit(form) {
        return api.put(`/zoho/crm`, { ...form, token: Account.getUrsToken() });
    }
    static zohoCrmDelete(id) {
        return api.post(`/zoho/crm_delete?id=${id}`, { token: Account.getUrsToken() });
    }
    //------AMO----------//
    static amoKey() {
        return api.get(`/amo/key`);
    }
    static amoUsers() {
        return api.get(`/amo/users`);
    }
    static amoDelete() {
        return api.post(`/amo/delete`,);
    }
    static amoCrmCreate(form) {
        return api.post(`/amo/crm`, { ...form, token: Account.getUrsToken() });
    }
    static amoCrmEdit(form) {
        return api.put(`/amo/crm`, { ...form, token: Account.getUrsToken() });
    }
    static amoCrmDelete(id) {
        return api.post(`/amo/crm_delete?id=${id}`, { token: Account.getUrsToken() });
    }
    //--------CUSTOM-------//
    static getCrmSip() {
        return api.get(`/custom_crm/sip`);
    }
    static getCrm() {
        return api.get(`/custom_crm/get`);
    }
    static createCustomCrm(current) {
        return api.post(`/custom_crm/create`, { ...current, token: Account.getUrsToken() });
    }
    static editCustomCrm(form) {
        return api.put(`/custom_crm/edit`, { ...form, token: Account.getUrsToken() });
    }
    static deleteCustomCrm(id) {
        return api.post(`/custom_crm/delete`, { id, token: Account.getUrsToken() });
    }

    //--------PIPEDRIVE--------//

    static pipedrive_domain(form) {
        return api.post(`/pipedrive/confirm`, { domain: form, urs: Account.getUrsToken() });
    }
    static pipedrive_delete() {
        return api.post(`/pipedrive/delete`, { urs: Account.getUrsToken() });
    }
    static pipedriveUsers() {
        return api.get(`/pipedrive/users`);
    }
    static pipedriveCrmCreate(form) {
        return api.post(`/pipedrive/crm`, { ...form, token: Account.getUrsToken() });
    }

    static pipedriveCrmEdit(form) {
        return api.put(`/pipedrive/crm`, { ...form, token: Account.getUrsToken() });
    }

    static pipedriveCrmDelete(id) {
        return api.post(`/pipedrive/crm_delete?id=${id}`, { token: Account.getUrsToken() });
    }

    //-------MONDAY-------//

    static monday_domain(form) {
        return api.post(`/monday/confirm?domain=${form}`, { domain: form, urs: Account.getUrsToken() });
    }
    static mondayUsers() {
        return api.get(`/monday/users`);
    }
    static monday_delete() {
        return api.post(`/monday/delete`, { urs: Account.getUrsToken() });
    }
    static mondayCrmCreate(form) {
        return api.post(`/monday/crm`, { ...form, token: Account.getUrsToken() });
    }
    static mondayCrmEdit(form) {
        return api.put(`/monday/crm`, { ...form, token: Account.getUrsToken() });
    }
    static mondayCrmDelete(id) {
        return api.post(`/monday/crm_delete?id=${id}`, { token: Account.getUrsToken() });
    }

    //--------ALTEGIO -------//
    static altegio_domain(crm_token) {
        return api.post(`/altegio/create`, { crm_token: crm_token, token: Account.getUrsToken() });
    }
    static altegio_create(sip) {
        return api.post(`/altegio/crm`, { sip, token: Account.getUrsToken() });
    }
    static altegio_get() {
        return api.get(`/altegio/get`);
    }
    static altegio_check() {
        return api.get(`/altegio/check`);
    }
    static altegio_crmDelete(id) {
        return api.post(`/altegio/crm_delete`, { id, token: Account.getUrsToken() });
    }
    static deleteAltegio() {
        return api.post(`/altegio/delete`, { token: Account.getUrsToken() });
    }
    //-------HUBSPOT-------//
    static hubspotDelete() {
        return api.post(`/hubspot/delete`, { token: Account.getUrsToken() });
    }
    static hubspotCode(code) {
        return api.post(`/hubspot/create`, { code,token: Account.getUrsToken() });
    }
    static hubspotUsers() {
        return api.get(`/hubspot/get`);
    }
    static hubspotCrmCreate(form) {
        return api.post(`/hubspot/crm`, { ...form, token: Account.getUrsToken() });
    }
    static hubspotCrmEdit(form) {
        return api.put(`/hubspot/crm`, { ...form, token: Account.getUrsToken() });
    }
    static hubspotCrmDelete(id) {
        return api.post(`/hubspot/crm_delete?id=${id}`, { token: Account.getUrsToken() });
    }
    //-------USERS------//

    static login(form) {
        return api.post('/users/login', form);
    }
    static loginEmployee(form) {
        return api.post('/sip_operator/sip_login', form);
    }
    static profileEmployee() {
        return api.get('/employee/profile');
    }
    static employeeWebrtc(body) {
        return api.post('/employee/webrtc', body);
    }
    static confirmEmployee(form) {
        return api.post('/sip_operator/confirm', form);
    }
    static getText() {
        return api.get('/ogg');
    }
    static userCrm() {
        return api.get('/users/crm');
    }
    static dropPass(phone) {
        return api.post('/users/drop_password', { phone, lang: lang[+localStorage.getItem('atsLang')] });
    }
    static dropPassVerify(phone, password) {
        return api.post('/users/drop_password_verify', { phone, password, lang: lang[+localStorage.getItem('atsLang')] });
    }
    static dropPassSuccess(phone, password) {
        return api.post('/users/drop_password_success', { phone, password, lang: lang[+localStorage.getItem('atsLang')] });
    }
    static terminated(id, terminated) {
        return urs.post(`/users/terminated`, { member_id: id, terminated, token: Account.getUrsToken() });
    }
    //----URS-----//

    static globalSearch(search) {
        return api.get(`/users/global_search?search=${search}&token=${Account.getUrsToken()}`);
    }
    static online(search) {
        return api.get(`/users/online`);
    }
    static ursOnline() {
        return urs.get(`/users/urs_online`);
    }
    static reset_pass(phone) {
        return urs.post(`/users/reset_pass`, { token: Account.getUrsToken(), phone });
    }
    static IP() {
        return api.get('/users/user_ip');
    }
    static blockedIp(search) {
        return api.get(`/ip/blocked_ip?search=${search}&token=${Account.getUrsToken()}`);
    }


    static register(phone, link) {
        return urs.post(`/users/register?token=${Account.getUrsToken()}&link=${link}`, { phone });
    }

    static registerUser(phone) {
        return urs.post(`/users/register_user`, { phone });
    }

    static registerUserVerify(phone, code) {
        return urs.post(`/users/register_user_verify?type=${process.env.REACT_APP_SERVER === 'ATS' ? 'ats' : ''}`, { phone, code });
    }

    static adminLogin(form) {
        return api.post('/users/admin_login', form);
    }

    static confirm(form) {
        return api.post('/users/confirm', form);
    }

    static editMember(form, token, lang, link) {
        return api.post(`/users/edit?token=${token}&lang=${lang}&link=${link}`, form);
    }

    static applyPromocode(code) {
        return api.post(`/users/apply_promocode`, { code });
    }

    static profile() {
        return api.get(`/users/profile?token=${Account.getUrsToken()}`);
    }

    static profileUrs() {
        return urs.get('/users/profile_urs');
    }

    static ursAdmins() {
        return urs.get('/users/urs_admins');
    }

    static saveUrsAdminTelegramUser(payload) {
        return urs.post('/users/urs_admin_users', payload);
    }

    static removeUrsAdminTelegramUser(adminId) {
        return urs.delete(`/users/urs_admin_users?adminId=${adminId}`);
    }

    static manager() {
        return api.get('/users/manager');
    }

    static members(page, search, billing, testmode, isblocked, matrix, gumar, isActive) {
        return urs.get(`/users/members?page=${page}${search ? '&search=' + search : ''}${billing ? '&billing=' + billing : ''}${testmode ? '&testmode=' + testmode : ''}${isblocked ? '&isblocked=' + isblocked : ''}${matrix ? '&matrix=' + matrix : ''}${gumar ? '&gumar=' + gumar : ''}${isActive ? '&isActive=' + isActive : ''}`);
    }

    static comment(id) {
        return urs.get(`/users/comment?member_id=${id}`);
    }

    static ursBlocked(id) {
        return urs.get(`/users/urs_blocked`);
    }

    static create_comment(form, link) {
        return urs.post(`/users/create_comment?link=${link}`, form);
    }

    static blocked(id, blocked) {
        return urs.post(`/users/blocked?blocked=${blocked}&member_id=${id}`);
    }

    static loginAsUser(id, original, key) {
        return urs.post(`/users/login_as_member`, { id, original, key });
    }

    static billing(form, link) {
        return urs.post(`/users/billing?link=${link}`, form);
    }
    static getBilling() {
        return urs.get(`/users/get_billing`);
    }
    static uploadINT(form) {
        return updateAndCreateApiAdmin.post(`/users/exel?link=${location.pathname}`, { exel: form, token: Account.getUrsToken() });
    }
    static uploadTurnOff(form) {
        return updateAndCreateApiAdmin.post(`/users/turnoff?link=${location.pathname}`, { exel: form, token: Account.getUrsToken() });
    }
    static test_mode(id, test, link) {
        return urs.post(`/users/test_mode?member_id=${id}&test=${test}&link=${link}`,);
    }

    //------BLOCK NOTE----//

    static inBasket(id, blocked) {
        return urs.post(`/users/member_in_block?member_id=${id}&blocked=${blocked}`,);
    }
    static sendUrsMessage(message, list) {
        return urs.post(`/users/sms_in_block`, { message, array: list });
    }
    static inBasketCount() {
        return urs.get(`/users/count_in_block`,);
    }

    static inBasketGet() {
        return urs.get(`/users/member_in_block`,);
    }

    static ursPromocodesUsers() {
        return urs.get(`/users/urs_promocodes_users`);
    }

    static ursPromocodes(memberId) {
        return urs.get(`/users/urs_promocodes${memberId ? `?member_id=${memberId}` : ''}`);
    }

    static ursPromocodesCreate(body) {
        return urs.post(`/users/urs_promocodes`, body);
    }

    static ursPromocodesDelete(id) {
        return urs.post(`/users/urs_promocodes_delete`, { id });
    }
    //-------IP ADDRESS-----/
    static createIp(ip, limit, page, search, sort, sortBy) {
        return urs.post(`/ip/create?link=${location.pathname}&limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}`, { ip, token: Account.getAdminToken(), urs: Account.getUrsToken() });
    }
    static getIpData(limit, page, search, sort, sortBy) {
        return urs.get(`/ip/get?link=${location.pathname}&token=${Account.getAdminToken()}&urs=${Account.getUrsToken()}&limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}`);
    }
    static deleteIp(ip) {
        return urs.post(`/ip/delete?link=${location.pathname}&id=${ip}`, { token: Account.getAdminToken(), urs: Account.getUrsToken() });
    }
    //-------SIP------//
    static sip(limit, page, search, sort, sortBy,) {
        return api.get(`/sip/get?limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}`);
    }
    static shortFunctionOperator() {
        return api.get(`/sip/mails`);
    }
    static sipMailsGet() {
        return api.get(`/sip/mails`);
    }
    static sipMailsSet(buddies) {
        return api.post(`/sip/mails`, { buddies });
    }
    static sip_ip() {
        return api.get(`/sip/sip_ip`);
    }

    static sipSingle(buddy) {
        const safeBuddy = encodeURIComponent(String(buddy));
        return api.get(`/sip/single?buddy=${safeBuddy}`);
    }

    static getCRM() {
        return api.get(`/sip/crm`);
    }

    static sipEdit(buddy, form, limit, page, search, link, lang, sort, sortBy) {
        return api.post(`/sip/edit?buddy=${buddy}&limit=${limit || 10}&page=${page || 1}&search=${search || ''}&lang=${lang}&link=${link}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}`, { ...form, token: Account.getUrsToken() });
    }

    static sipDelete(form) {
        return api.post(`/sip/delete?link=${location.pathname}`, form);
    }

    static sipTelegramCreate(form) {
        return api.post(`/sip/telegram?link=${location.pathname}/create_telegram`, { ...form, urs: Account.getUrsToken() });
    }
    static sipGlobalChange(arr, form) {
        return api.post(`/sip/update_global?link=${location.pathname}`, { ...form, arr, urs: Account.getUrsToken() });
    }

    static sipTelegramDelete(buddy) {
        return api.post(`/sip/telegram_delete?buddy=${buddy}&link=${location.pathname}/delete_telegram`, { urs: Account.getUrsToken() });
    }

    static sipCreate(buddy, multiple, token, issip, limit, page, search, lang, sort, sortBy) {
        return api.post(`/sip/create?count=${buddy}&issip=${issip}&limit=${limit || 10}&page=${page || 1}&search=${search || ''}&lang=${lang}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}&link=${location.pathname}/sip_create`, { token, multiple });
    }

    static crmCreate(form) {
        return api.post(`/sip/create_crm?link=${location.pathname}/crm_create`, { ...form, urs: Account.getUrsToken() });
    }

    static crmEdit(form) {
        return api.post(`/sip/edit_crm?link=${location.pathname}/crm_edit`, { ...form, urs: Account.getUrsToken() });
    }

    static crmDelete(id, buddy) {
        return api.post(`/sip/delete_crm?id=${id}&buddy=${buddy}&link=${location.pathname}/delete_crm`, { urs: Account.getUrsToken() });
    }

    static crmSingle(id) {
        return api.get(`/sip/single_crm?id=${id}&token=${Account.getUrsToken()}`);
    }


    //-------ALLOWED PHONE ------//
    static allowed(limit, page, search, sort, sortBy) {
        return api.get(`/allowed/get?limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}`);
    }
    static allowedUpload(form, limit, page, search, sort, sortBy) {
        return updateAndCreateApi.post(`/allowed/upload?link=${location.pathname}&limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}`, { exel: form, token: Account.getUrsToken() });
    }

    static provider() {
        return api.get(`/allowed/provider`);
    }
    static generate(num) {
        return api.get(`/allowed/generate_short?num=${num}`);
    }

    static allowedCreate(limit, page, search, form, multiple, sort, sortBy) {
        return api.post(`/allowed/create?limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}&link=${location.pathname}/create`, { ...form, multiple, token: Account.getUrsToken() });
    }

    static allowedEdit(limit, page, search, form, sort, sortBy) {
        return api.post(`/allowed/edit?limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}&link=${location.pathname}/edit`, { ...form, urs: Account.getUrsToken() });
    }

    static allowedSingle(id) {
        return api.get(`/allowed/single?id=${id}`);
    }

    static allowedDelete(id) {
        return api.post(`/allowed/delete?id=${id}&link=${location.pathname}/delete`, { urs: Account.getUrsToken() });
    }
    static allowedDeleteAll(id) {
        return api.post(`/allowed/delete_with?id=${id}&link=${location.pathname}/delete`, { urs: Account.getUrsToken() });
    }

    //-------SHORT------//
    static short(limit, page, search, sort, sortBy) {
        return api.get(`/virtual/get?limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}`);
    }
    static shortForVirtual() {
        return api.get('/virtual/get_for_virtual');
    }
    static shortGetShortNumbers() {
        return api.get(`/virtual/get_short_numbers`);
    }
    static shortCreate(limit, page, search, form, sort, sortBy) {
        return api.post(`/virtual/create?limit=${limit || 10}&page=${page || 1}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}&search=${search || ''}&lang=${lang[+localStorage.getItem('atsLang')]}&link=${location.pathname}/create`, { ...form, urs: Account.getUrsToken() });
    }

    static shortEdit(limit, page, search, id, form, sort, sortBy) {
        return api.post(`/virtual/edit?id=${id}&limit=${limit || 10}&page=${page || 1}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}&search=${search || ''}&lang=${lang[+localStorage.getItem('atsLang')]}&link=${location.pathname}/edit`, { ...form, urs: Account.getUrsToken() });
    }

    static shortSip() {
        return api.get(`/virtual/sip`);
    }

    static shortSingle(id) {
        return api.get(`/virtual/single?id=${id}`);
    }

    static shortDelete(id) {
        return api.post(`/virtual/delete?id=${id}&link=${location.pathname}/delete`, { urs: Account.getUrsToken() });
    }

    //-------SHORTFunction------//
    static shortFunctionGet() {
        return api.get(`/api/get`);
    }
    static shortFunctionGetList() {
        return api.get(`/api/get_list`);
    }

    static shortFunctionEdit(form) {
        return api.post(`/api/edit?link=${location.pathname}&urs=${Account.getUrsToken()}`, form);
    }
    static shortFunctionDelete(form) {
        return api.post(`/api/delete?link=${location.pathname}&urs=${Account.getUrsToken()}`, {id:form});
    }

    //-------IVR------//

    static IVR(limit, page, search, sort, sortBy) {
        return api.get(`/ivr/get?lang=${lang[+localStorage.getItem('atsLang')]}&limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sort ? '&sort=' + sort : ''}${sortBy ? '&sortBy=' + sortBy : ''}`);
    }

    static singleIvr(id) {
        return api.get(`/ivr/single?id=${id}`);
    }
    static getReminder(id) {
        return api.get(`/ivr/reminder?id=${id}`);
    }
    static deleteReminder(id) {
        return api.delete(`/ivr/reminder?id=${id}&urs=${Account.getUrsToken()}`);
    }
    static editReminder(time, phone, ivr, ivrId, id) {
        return api.put(`/ivr/reminder`, { id, time, phone, ivr, ivrId, urs: Account.getUrsToken() });
    }
    static createReminder(time, phone, ivr, ivrId) {
        return api.post(`/ivr/reminder`, { time, phone, ivr, ivrId, urs: Account.getUrsToken() });
    }

    static createIvr(limit, page, search, form) {
        return api.post(`/ivr/create?lang=${lang[+localStorage.getItem('atsLang')]}&limit=${limit || 10}&page=${page || 1}&search=${search || ''}&link=${location.pathname}`, { urs: Account.getUrsToken(), ...form });
    }

    static editIvr(limit, page, search, id, form) {
        return api.post(`/ivr/edit?id=${id}&lang=${lang[+localStorage.getItem('atsLang')]}&limit=${limit || 10}&page=${page || 1}&search=${search || ''}&link=${location.pathname}`, { urs: Account.getUrsToken(), ...form });
    }

    static deleteIvr(id) {
        return api.post(`/ivr/delete?id=${id}&lang=${lang[+localStorage.getItem('atsLang')]}&link=${location.pathname}`, { urs: Account.getUrsToken() });
    }

    //----------DID----------//

    static getCreateDid() {
        return api.get(`/did/getDidPear?token=${Account.getUrsToken()}`);
    }

    static createDid(form, limit, page) {
        return api.post(`/did/create?link=${location.pathname}&page=${page || 1}&limit=${limit || 10}`, { ...form, token: Account.getUrsToken() });
    }

    static editDid(form, provider, limit, page) {
        return api.post(`/did/edit?link=${location.pathname}&provider=${provider}&page=${page || 1}&limit=${limit || 10}`, { ...form, token: Account.getUrsToken() });
    }

    static deleteDid(phone, provider) {
        return api.post(`/did/delete?phone=${phone}&link=${location.pathname}&provider=${provider}`, { token: Account.getUrsToken() });
    }

    static telegReg(phone) {
        return api.post(`/did/telegram_provider_create?phone=${phone}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }

    static telegRegVerify(phone, code, session_id, storage_id) {
        return api.post(`/did/telegram_provider_verify?phone=${phone}&code=${code}&session_id=${session_id}&storage_id=${storage_id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }

    static telegRegVerifyEmail(phone, code, session_id, storage_id) {
        return api.post(`/did/telegram_provider_verify_email?phone=${phone}&code=${code}&session_id=${session_id}&storage_id=${storage_id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }

    static telegRegDelete(username) {
        return api.post(`/did/telegram_provider_delete?username=${username}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }


    static getDid(search, limit, page) {
        return api.get(`/did/get?search=${search || ''}&page=${page || 1}&limit=${limit || 10}`);
    }

    static singleDid(phone, provider) {
        return api.get(`/did/single?phone=${phone}&provider=${provider}&token=${Account.getUrsToken()}`);
    }

    //---------OTHER SIP ----------//

    static getProvider(search, limit, page) {
        return api.get(`/other_sip/get?search=${search || ''}&page=${page || 1}&limit=${limit || 10}`);
    }

    static getSingleProvider(id) {
        return api.get(`/other_sip/single?id=${id}&token=${Account.getUrsToken()}`);
    }

    static createProvider(form, limit, page) {
        return api.post(`/other_sip/create?link=${location.pathname}&page=${page || 1}&limit=${limit || 10}`, { ...form, token: Account.getUrsToken() });
    }

    static editProvider(form, limit, page) {
        return api.post(`/other_sip/edit?link=${location.pathname}&page=${page || 1}&limit=${limit || 10}`, { ...form, token: Account.getUrsToken() });
    }

    static deleteProvider(id) {
        return api.post(`/other_sip/delete?id=${id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }


    //-------FORWARD-------//
    static createForward(limit, page, search, form,) {
        return api.post(`/forward/create?limit=${limit || 10}&page=${page || 1}&search=${search || ''}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }

    static editForward(limit, page, search, form,) {
        return api.post(`/forward/edit?limit=${limit || 10}&page=${page || 1}&search=${search || ''}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }

    static deleteForward(id) {
        return api.post(`/forward/delete?id=${id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }

    static getSelect(type) {
        return api.get(`/forward/get_select?type=${type}`);
    }

    static getSingle(id) {
        return api.get(`/forward/single?id=${id}`);
    }

    static getForward(limit, page, search, sortBy, sortOrder) {
        return api.get(`/forward/get?limit=${limit || 10}&page=${page || 1}&search=${search || ''}${sortOrder ? '&sortOrder=' + sortOrder : ''}${sortBy ? '&sortBy=' + sortBy : ''}`);
    }


    //-------CALL ROUT-------//
    static getCreateSelectForward() {
        return api.get(`/call_rout/get_select`);
    }

    static getSingleRoute(id) {
        return urs.get(`/call_rout/single?id=${id}`);
    }

    static getCallRout(limit, page, search, sortBy, sortOrder) {
        return api.get(`/call_rout/get?limit=${limit || 10}&page=${page || 1}&search=${search || ''}&token=${Account.getUrsToken()}${sortOrder ? '&sortOrder=' + sortOrder : ''}${sortBy ? '&sortBy=' + sortBy : ''}`);
    }

    static createCallRout(limit, page, search, form) {
        return api.post(`/call_rout/create?limit=${limit || 10}&page=${page || 1}&search=${search || ''}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }

    static editCallRout(limit, page, search, id, form) {
        return api.post(`/call_rout/edit?limit=${limit || 10}&page=${page || 1}&search=${search || ''}&link=${location.pathname}&id=${id}`, { ...form, token: Account.getUrsToken() });
    }

    static deleteCallRout(id) {
        return urs.post(`/call_rout/delete?id=${id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }


    //-------BLOCKED-------//

    static getBlocked(limit, page, search) {
        return api.get(`/blocked/get?limit=${limit || 10}&page=${page || 1}&search=${search || ''}`);
    }

    static createBlocked(limit, page, search, form) {
        return api.post(`/blocked/create?limit=${limit || 10}&page=${page || 1}&search=${search || ''}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }

    static deleteBlocked(id) {
        return api.post(`/blocked/delete?id=${id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }


    //-------FILE-------//

    static fileCreate(form) {
        return updateAndCreateApi.post(`/files/create?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }

    static fileGet(all) {
        return api.get(`/files/get?all=${all || ''}`);
    } 
    
    static fileChangeName(uid,name) {
        return api.post(`/files/change_name?uid=${uid}&name=${name}`);
    }
    static download(uid) {
        return api.get(`/files/download?uid=${uid}`, { responseType: 'blob' });
    }

    static fileDelete(id) {
        return api.post(`/files/delete?id=${id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }
    static fileEdit(id, musicHold, type) {
        return api.post(`/files/update?id=${id}&musicHold=${musicHold}&type=${type}`, { token: Account.getUrsToken() });
    }

    static fileIdict(form) {
        return api.post(`/files/idict?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }

    static fileYandex(form) {
        return api.post(`/files/yandex?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static fileWav(form) {
        return api.post(`/files/wav?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static fileOpenAi(form) {
        return api.post(`/open-ai/create?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static fetchOpenAi(id) {
        return api.get(`/open-ai/check?id=${id}`);
    }
    static getGeneratedFiles(ai) {
        return api.get(`/open-ai/get_generated_files?ai=${ai}`);
    }

    static getPreCallAnnouncement() {
        return api.get(`/pre_call_announcement/get`);
    }
    static createPreCallAnnouncement(form) {
        return updateAndCreateApi.post(`/pre_call_announcement/create?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static editPreCallAnnouncement(form, id) {
        return api.post(`/pre_call_announcement/edit?id=${id}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static disablePreCallAnnouncement() {
        return api.post(`/pre_call_announcement/disable?link=${location.pathname}`, { token: Account.getUrsToken() });
    }
    static getCallback() {
        return api.get(`/api/callback/get`);
    }
    static getCallbackMail() {
        return api.get(`/api/callback_mail/get`);
    }
    static createCallbackMail(form) {
        return api.post(`/api/callback_mail/create?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static editCallbackMail(form) {
        return api.post(`/api/callback_mail/edit?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static deleteCallbackMail(email) {
        return api.post(`/api/callback_mail/delete?link=${location.pathname}`, { email, token: Account.getUrsToken() });
    }
    static createCallback(form) {
        return updateAndCreateApi.post(`/api/callback/create?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static editCallback(form) {
        return updateAndCreateApi.post(`/api/callback/edit?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static deleteCallback(id) {
        return api.post(`/api/callback/delete?link=${location.pathname}`, { id, token: Account.getUrsToken() });
    }
    //-------CL GROUP-------//
    static clGet() {
        return api.get(`/users/clgroup`);
    }

    static money() {
        return api.get(`/users/money`);
    }
    static prices() {
        return api.get(`/users/prices`);
    }

    static moneyHistory() {
        return api.get(`/users/money_history`);
    }

    //------AUTO CALL--------//
    static getInAuto() {
        return api.get(`/auto_call/get_in`);
    }

    static getAuto() {
        return api.get(`/auto_call/get`);
    }

    static createAuto(form) {
        return api.post(`/auto_call/create?lang=${lang[+localStorage.getItem('atsLang')]}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }

    static editAuto(form, id) {
        return api.post(`/auto_call/edit?lang=${lang[+localStorage.getItem('atsLang')]}&id=${id}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static editAutoStatus(id, form,) {
        return api.post(`/auto_call/edit_status?lang=${lang[+localStorage.getItem('atsLang')]}&id=${id}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }

    static singleAuto(id) {
        return api.get(`/auto_call/single?lang=${lang[+localStorage.getItem('atsLang')]}&id=${id}`);
    }

    static deleteItem(id) {
        return api.post(`/auto_call/delete_item?lang=${lang[+localStorage.getItem('atsLang')]}&id=${id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }

    static deleteAuto(id, grp) {
        return api.post(`/auto_call/delete?lang=${lang[+localStorage.getItem('atsLang')]}&id=${id}${grp ? '&grp=' + grp : ''}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }
    static autoCallUpload(exel, id, form) {
        return updateAndCreateApi.post(`/auto_call/upload?id=${id}&lang=${lang[+localStorage.getItem('atsLang')]}`, { exel, ...form, token: Account.getUrsToken() });
    }

    //------CONFERENCE CALL--------//
    static getConferenceCallIn() {
        return api.get(`/conference_call/get_in`);
    }
    static getConferenceCall() {
        return api.get(`/conference_call/get`);
    }
    static createConferenceCall(form) {
        return api.post(`/conference_call/create?link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static editConferenceCall(form, id) {
        return api.post(`/conference_call/edit?id=${id}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static editConferenceCallStatus(id, form) {
        return api.post(`/conference_call/edit_status?id=${id}&link=${location.pathname}`, { ...form, token: Account.getUrsToken() });
    }
    static singleConferenceCall(id) {
        return api.get(`/conference_call/single?id=${id}`);
    }
    static deleteConferenceCallItem(id) {
        return api.post(`/conference_call/delete_item?id=${id}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }
    static deleteConferenceCall(id, grp) {
        return api.post(`/conference_call/delete?id=${id}${grp ? '&grp=' + grp : ''}&link=${location.pathname}`, { token: Account.getUrsToken() });
    }

    //------HISTORY--------//
    static history(row, page, filter) {
        return api.get(`/history/get?page=${page || 1}&limit=${row || 10}${filter?.disposition ? '&disposition=' + filter.disposition : ''}${filter.number ? '&number=' + filter.number : ''}${filter.startTime ? '&startTime=' + new Date(filter.startTime).toISOString() : ''}${filter.endTime ? '&endTime=' + new Date(filter.endTime).toISOString() : ''}${filter.status ? '&status=' + filter.status : ""}${filter.line ? '&line=' + filter.line : ''}${filter.period ? '&period=' + filter.period : ''}${filter.caller ? '&caller=' + filter.caller : ''}${filter.did ? '&did=' + filter.did : ""}${filter.rate ? '&rate=' + filter.rate : ""}${filter.virtual != null && filter.virtual !== '' ? '&virtual=' + filter.virtual : ''}${filter?.member_all ? '&member_all=true' : ''}${Cookies.get('member') ? '&member=' + Cookies.get('member') : ''}`);
    }

    static graphic(type, isTrue, filter) {
        return api.get(`/history/graphic?type=${type}&isTrue=${isTrue}${filter.timeStartStart ? '&timeStartStart=' + filter.timeStartStart : ''}${filter.timeEndEnd ? '&timeEndEnd=' + filter.timeEndEnd : ''}${filter.caller ? '&caller=' + filter.caller : ''}${filter.did ? '&did=' + filter.did : ''}${filter.number ? '&number=' + filter.number : ''}${filter.virtual != null && filter.virtual !== '' ? '&virtual=' + filter.virtual : ''}`);
    }

    static duration(filter) {
        return api.get(`/history/duration?page=1${filter?.disposition ? '&disposition=' + filter.disposition : ''}${filter.number ? '&number=' + filter.number : ''}${filter.startTime ? '&startTime=' + new Date(filter.startTime).toISOString() : ''}${filter.endTime ? '&endTime=' + new Date(filter.endTime).toISOString() : ''}${filter.status ? '&status=' + filter.status : ""}${filter.line ? '&line=' + filter.line : ''}${filter.period ? '&period=' + filter.period : ''}${filter.caller ? '&caller=' + filter.caller : ''}${filter.did ? '&did=' + filter.did : ""}`);
    }

    static getAllowed() {
        return api.get(`/history/allowed?member=${Cookies.get('member')}`);
    }

    static getEmotions(url) {
        return api.get(`/history/emotion?file=${url}`);
    }
    static getHy(url) {
        return api.get(`/history/armenian_text?file=${url}`);
    }
    static createHy(url) {
        return api.post(`/history/armenian_text?file=${url}`);
    }


    //---------REPORT----------//
    static getReport(nm) {
        return urs.get(`/users/month_report${nm ? '?nm=1' : ''}${nm ? '&' : '?'}link=${location.pathname}`);
    }

    static getVoip(start, end) {
        return urs.get(`/users/voip?start=${start}&end=${end}&link=${location.pathname}`);
    }

    static getUsed() {
        return urs.get(`/users/used?link=${location.pathname}`);
    }

    //------LOGS-------//

    static getLogs(limit, page, filter) {
        return api.get(`/logs/get?id=${Cookies.get('viewer')}&page=${page || 1}&limit=${limit || 10}${filter?.startTime ? '&start=' + filter.startTime : ''}${filter?.endTime ? '&end=' + filter.endTime : ''}${filter.type ? '&type=' + filter.type : ''}${filter.method ? '&method=' + filter.method : ""}${filter.isAdmin ? '&isAdmin=' + filter.isAdmin : ''}`);
    }
    static statistic(type,id) {
        return api.get(`/logs/statistic?id=${id || Cookies.get('viewer')}&type=${type}`);
    }
    static getSingleLogs(id) {
        return api.get(`/logs/single?id=${id}`);
    }

    //------NEWS-------//

    static getNewsList() {
        return urs.get(`/news/list`);
    }
    static getNewsSingle(id) {
        return urs.get(`/news/single?id=${id}`);
    }
    static deleteNewsSingle(id) {
        return urs.delete(`/news/delete?id=${id}`);
    }
    static createNews(form) {
        return updateAndCreateApiAdmin.post(`/news/create`, form);
    }
    static updateNews(form) {
        return updateAndCreateApiAdmin.put(`/news/edit`, form);
    }
    static getNews(device) {
        return api.get(`/news/get?device=${device || 0}`);
    }
    static statusNews(status) {
        return api.put(`/news/status?status=${status}`);
    }
    static createStatistic(id){
        return api.post(`/news/statistic`,{news_id:id});
    
    }
    static connectNews(id,number){
        return api.post(`/news/connect`,{news_id:id,number});
    
    }
    static getStatistic(){
        return urs.get(`/news/statistic`);
    
    }
    static newsDeleteImage(id){
        return urs.delete(`/news/delete_image?id=${id}`);
    
    }

    //------HELPDESK-------//
    static getHelpDeskList(params = {}) {
        const q = new URLSearchParams(params).toString();
        return api.get(`/helpdesk/articles${q ? `?${q}` : ''}`);
    }
    static getHelpDeskOne(id) {
        return api.get(`/helpdesk/articles/${id}`);
    }
    static createHelpDesk(payload) {
        return api.post('/helpdesk/articles', payload);
    }
    static updateHelpDesk(id, payload) {
        return api.put(`/helpdesk/articles/${id}`, payload);
    }
    static deleteHelpDesk(id) {
        return api.delete(`/helpdesk/articles/${id}`);
    }

    //-------REZX-------//
    static createRezx(code) {
        return api.post(`/rezx/create`, { code,token: Account.getUrsToken() });
    }
    static getRezxSip() {
        return api.get(`/rezx/get`,);
    }
    static createRezxSip(buddy) {
        return api.post(`/rezx/crm_create`, { buddy,token: Account.getUrsToken() });
    }
    static deleteRezxSip(id) {
        return api.post(`/rezx/crm_delete?id=${id}`, { id,token: Account.getUrsToken() });
    }

    //-------LUA-------//
    static createLua(code) {
        return api.post(`/lua/create`, { code,token: Account.getUrsToken() });
    }
    static getLuaSip() {
        return api.get(`/lua/get`,);
    }
    static createLuaSip(buddy) {
        return api.post(`/lua/crm_create`, { buddy,token: Account.getUrsToken() });
    }
    static deleteLuaSip(id) {
        return api.post(`/lua/crm_delete?id=${id}`, { id,token: Account.getUrsToken() });
    }
    static deleteLua(id) {
        return api.post(`/lua/delete?id=${id}`, { id,token: Account.getUrsToken() });
    }

    //------HELP-------//
    static createHelp(form) {
        return api.post(`/help/create`, { ...form, token: Account.getUrsToken() });
    }
    static askHelpAi(form) {
        return api.post(`/help/ai`, { ...form, token: Account.getUrsToken() });
    }
    static getHelp(limit, page, search, sortBy, sortOrder) {
        return api.get(`/help/get?limit=${limit || 10}&page=${page || 1}&search=${search || ''}&token=${Account.getUrsToken()}${sortOrder ? '&sortOrder=' + sortOrder : ''}${sortBy ? '&sortBy=' + sortBy : ''}`);
    }
    static getHelpHistory() {
        return api.get(`/help/history`);
    }

    //------SHORT FUNCTION-------//
    static handleIp(ips) {
        return api.post(`/api/handle_ip`, { ips, token: Account.getUrsToken() });
    }
    static getIp() {
        return api.get(`/api/get_ip`);
    }
    static shortOperatorCounts() {
        return api.get(`/short_sip/counts`);
    }
    static shortSipGet(type) {
        return api.get(`/short_sip/get?type=${type}`);
    }
    static shortSipList() {
        return api.get(`/short_sip/get_all`);
    }
    static shortSipSpeech(buddies) {
        return api.post(`/short_sip/speech`, { buddies, token: Account.getUrsToken() });
    }
    static shortSipRate(buddies) {
        return api.post(`/short_sip/rate`, { buddies, token: Account.getUrsToken() });
    }

    static aiAnalyticsConfigGet() {
        return api.get(`/ai_analytics/config`);
    }
    static aiAnalyticsOperatorsGet() {
        return api.get(`/ai_analytics/operators`);
    }
    static aiAnalyticsOperatorsSave(payload) {
        return api.post(`/ai_analytics/operators`, { ...payload, token: Account.getUrsToken() });
    }

    //------WIDGET-------//
    static widgetEmbed() {
        return api.get(`/widget/embed`);
    }
    static widgetRefresh() {
        return api.post(`/widget/refresh`);
    }
    static widgetRevoke() {
        return api.post(`/widget/revoke`);
    }

    static widgetSaveIps(ips) {
        return api.post(`/widget/save_ips`, { ips, token: Account.getUrsToken() });
    }
    static widgetGetIps() {
        return api.get(`/widget/get_ips`);
    }   

    //------COMUNICATION-------//
    static whatsappGet() {
        return api.get(`/comunication/whatsapp_get`);
    }
    static whatsappDelete(id) {
        return api.post(`/comunication/whatsapp/delete`, { id, token: Account.getUrsToken() });
    }
    static whatsappAddGroup(body) {
        return api.post(`/comunication/whatsapp/add_group`, { ...body, token: Account.getUrsToken() });
    }
    static whatsappCreate(body) {
        return api.post(`/comunication/whatsapp/create`, { ...body, token: Account.getUrsToken() });
    }
    static whatsappEmbeddedFinish(form) {
        return api.post(`/comunication/whatsapp/embedded/finish`, { ...form, token: Account.getUrsToken() });
    }
    static telegramGet() {
        return api.get(`/comunication/telegram`);
    }
    static telegramStart(phone, groupId) {
        return api.post(`/comunication/telegram/connect/start`, { phone, groupId, token: Account.getUrsToken() });
    }
    
    static telegramCode(code, accountId) {
        return api.post(`/comunication/telegram/connect/code`, { code, accountId, token: Account.getUrsToken() });
    }
    static telegramPassword(password, accountId) {
        return api.post(`/comunication/telegram/connect/password`, { password, accountId,   token: Account.getUrsToken() });
    }
    static telegramDelete(accountId) {
        return api.post(`/comunication/telegram/connect/delete`, { accountId, token: Account.getUrsToken() });
    }
    static telegramUpdate(accountId, groupId) {
        return api.post(`/comunication/telegram/connect/update`, { accountId, groupId, token: Account.getUrsToken() });
    }


    //-------TELEGRAM-------//
    static telegramIncluded() {
        return api.get(`/comunication/telegram/included`);
    }
    static telegramMain() {
        return api.get(`/comunication/telegram/main`);
    }

    //-------EMPLOYEE-------//
    static employeeGet(id) {
        return api.get(`/employee/get?id=${id}&member=${Cookies.get('member') || ""}`);
    }
    static employeeFixShorts(id) {
        return api.post(`/employee/fix_shorts?id=${id}`, { token: Account.getUrsToken() });
    }
    static employeeEdit(form) {
        return api.post(`/employee/edit?member=${Cookies.get('member') || ""}`, {...form, token: Account.getUrsToken()});
    }
    static employeeCreate(form) {
        return api.post(`/employee/create?member=${Cookies.get('member') || ""}`, {...form, token: Account.getUrsToken()});
    }
    static generateBuddy() {
        return api.post(`/employee/generate_buddy`);
    }
    static deleteBuddy(generatedBuddy) {
        return api.post(`/employee/delete_buddy`, { generatedBuddy, token: Account.getUrsToken() });
    }
    static employeeGetEmployees() {
        return api.get(`/employee/get_employees?member=${Cookies.get('member') || ""}`);
    }

    // SMS (separate from employee module)
    static smsGetRecipients() {
        return api.get('/sms/recipients');
    }
    static smsSend(buddies, message, phonesOrRecipients, sendAt, channel, options = {}) {
        const list = Array.isArray(phonesOrRecipients) ? phonesOrRecipients : [];
        const hasObjects = list.some((x) => x && typeof x === 'object' && !Array.isArray(x));
        const phones = hasObjects ? list.map((r) => r?.phone).filter(Boolean) : list;
        const body = {
            buddies: buddies || [],
            message,
            phones: phones || [],
            ...(hasObjects ? { recipients: list } : {}),
            channel: channel || 'whatsapp'
        };
        if (sendAt) body.send_at = sendAt;
        if (options?.telegram_account_id != null) body.telegram_account_id = options.telegram_account_id;
        return api.post('/sms/send', body);
    }

    /** Telegram bulk send via dedicated route. Body supports { telegram_account_id, message, phones?, recipients?, template_id?, delay_ms? }. */
    static smsTelegramSend(body) {
        return api.post('/sms/telegram/send', body);
    }
    static smsParseFile(file) {
        const form = new FormData();
        form.append('file', file);
        return api.post('/sms/parse_file', form, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
    static smsGetMetaTemplates(waPhoneId) {
        const params = waPhoneId != null ? { wa_phone_id: waPhoneId } : {};
        return api.get('/sms/meta/templates', { params });
    }
    static smsCreateMetaTemplate(body) {
        return api.post('/sms/meta/templates', body);
    }
    /** Send WhatsApp template messages. Body: { wa_phone_id, items: [{ phone, template_name, language?, components? }] } */
    static smsSendWhatsAppTemplates(body) {
        return api.post('/sms/whatsapp/send-templates', body);
    }
    static smsSendWhatsAppText(body) {
        return api.post('/sms/whatsapp/send-text', body);
    }
    static smsSendWhatsAppMedia({ wa_phone_id, to, caption, file }) {
        const form = new FormData();
        form.append('wa_phone_id', String(wa_phone_id));
        form.append('to', String(to));
        if (caption != null && String(caption).trim() !== '') form.append('caption', String(caption).trim());
        form.append('file', file);
        return api.post('/sms/whatsapp/send-media', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
    static smsTestWhatsAppTemplate(body) {
        return api.post('/sms/test-whatsapp-template', body);
    }
    static employeeDelete(id, ) {
        return api.post(`/employee/delete?id=${id}`, { token: Account.getUrsToken(), id });
    }
    static employeeUpload(exel) {
        return updateAndCreateApiAdmin.post(`/employee/upload`, { exel, token: Account.getUrsToken() });
    }
    //-------GROUPS-------//

    static groupsGet(all) {
        return api.get(`/groups/get?all=${all || 0}&member=${Cookies.get('member') || ""}`);
    }
    static groupsCreate(form) {
        return api.post(`/groups/create?member=${Cookies.get('member') || ""}`, form);
    }
    static groupsUpdate(id,form) {
        return api.post(`/groups/update?id=${id}&member=${Cookies.get('member') || ""}`, form);
    }
    static groupsGetSingle(id) {
        return api.get(`/groups/get_single?id=${id}&member=${Cookies.get('member') || ""}`);
    }
    static groupsDelete(id) {
        return api.post(`/groups/delete?id=${id}`);
    }

    //-------IVRS-------//
    static ivrsCreate(form) {
        return api.post(`/ivrs/create?member=${Cookies.get('member') || ""}`, form);
    }
    static ivrsUpdate(id,form) {
        return api.post(`/ivrs/update?id=${id}&member=${Cookies.get('member') || ""}`, form);
    }
    static ivrsGet() {
        return api.get(`/ivrs/get?member=${Cookies.get('member') || ""}`);
    }
    static ivrsCreateMenu(form) {
        return api.post(`/ivr/create_menu`, form);
    }
    static ivrsUpdateMenu(id,form) {
        return api.post(`/ivr/update_menu?id=${id}`, form);
    }
   
    //-------TELEGRAM CHATS-------//
    static telegramChatsGet(accountId,refresh = 0) {
        return api.get(`/telegramChats/get?accountId=${accountId}&refresh=${refresh}`);
    }
    static telegramUnreadTotal(accountId) {
      return api.get(`/telegramChats/unread_total?accountId=${accountId}`);
    }
    /** Sum unread across every telegram_session row for the logged-in member (same as /sms/unread_totals telegram side). */
    static telegramUnreadTotalAllForMember() {
      return api.get(`/telegramChats/unread_total?all=1`);
    }
    static telegramMessagesGet(accountId, chatId, { afterMessageId, limit }) {
        return api.get(`/telegramChats/messages?accountId=${accountId}&chatId=${chatId}${afterMessageId ? '&afterMessageId=' + afterMessageId : ''}${limit ? '&limit=' + limit : ''}`);
    }
    static telegramMessagesSend(accountId, chatId, message, answerer) {
        const body = { text: message };
        if (answerer != null && String(answerer).trim() !== '') body.answerer = String(answerer).trim();
        return api.post(`/telegramChats/messages/send?accountId=${accountId}&chatId=${chatId}`, body);
    }
    static telegramFileGet(accountId, chatId, messageId) {
        return api.get(`/telegramChats/file/${accountId}/${chatId}/${messageId}`, { responseType: 'blob' });
    }
    static telegramChatRead(accountId, chatId) {
        return api.post(`/telegramChats/chat/read?accountId=${accountId}&chatId=${chatId}`);
    }
    //-------WHATSAPP CHATS-------//
    static whatsappConversationsGet({ wa_phone_row_id, wa_phone_id, q, limit } = {}) {
        const params = new URLSearchParams();
        if (wa_phone_row_id != null) params.set('wa_phone_row_id', String(wa_phone_row_id));
        if (wa_phone_id != null) params.set('wa_phone_id', String(wa_phone_id));
        if (q != null && String(q).trim() !== '') params.set('q', String(q).trim());
        if (limit != null) params.set('limit', String(limit));
        const query = params.toString();
        return api.get(`/sms/conversations${query ? `?${query}` : ''}`);
    }
    static whatsappConversationGet(conversationId, { wa_phone_row_id, wa_phone_id, page, limit } = {}) {
        const params = new URLSearchParams();
        if (wa_phone_row_id != null) params.set('wa_phone_row_id', String(wa_phone_row_id));
        if (wa_phone_id != null) params.set('wa_phone_id', String(wa_phone_id));
        if (page != null) params.set('page', String(page));
        if (limit != null) params.set('limit', String(limit));
        const query = params.toString();
        return api.get(`/sms/conversation/${encodeURIComponent(conversationId)}${query ? `?${query}` : ''}`);
    }
    static whatsappUnreadTotal({ wa_phone_row_id } = {}) {
      return api.get(`/sms/whatsapp/unread_total${wa_phone_row_id != null ? `?wa_phone_row_id=${wa_phone_row_id}` : ''}`);
    }
    static whatsappMarkConversationRead(conversationId, { wa_phone_row_id } = {}) {
      return api.post(`/sms/whatsapp/mark_read`, { conversationId, wa_phone_row_id });
    }
    static unreadTotals() {
      return api.get(`/sms/unread_totals`);
    }
    //-------ROLES-------//
    static rolesList() {
        return api.get(`/roles/list`);
    }
    static rolesGet(roleKeyOrId) {
        const isNumeric = typeof roleKeyOrId === 'number' || (typeof roleKeyOrId === 'string' && /^\d+$/.test(roleKeyOrId));
        const q = isNumeric ? `id=${roleKeyOrId}` : `role_key=${encodeURIComponent(roleKeyOrId)}`;
        return api.get(`/roles/get?${q}`);
    }

    static rolesCreate(form) {
        return api.post(`/roles/create`, form);
    }
    static rolesUpdate(id,form) {
        return api.post(`/roles/update?id=${id}`, form);
    }
    static rolesDelete(id) {
        return api.post(`/roles/delete?id=${id}`);
    }
    static rolesSaveAll(form) {
        return api.post(`/roles/saveAll`, form);
    }

    //-------GRAPH REPORTS-------//
    static getMainNumbers() {
        return api.get(`/graph_report/main-numbers`);
    }
    static getShortDataINDID() {
        return api.get(`/employee/get_short_data`);
    }
    static reportHistory(page, limit, filter) {
        return api.get(`/graph_report/history?page=${page || 1}&limit=${limit || 10}${filter?.disposition ? '&disposition=' + filter.disposition : ''}${filter.number ? '&number=' + filter.number : ''}${filter.startTime ? '&startTime=' + new Date(filter.startTime).toISOString() : ''}${filter.endTime ? '&endTime=' + new Date(filter.endTime).toISOString() : ''}${filter.status ? '&status=' + filter.status : ""}${filter.line ? '&line=' + filter.line : ''}${filter.period ? '&period=' + filter.period : ''}${filter.caller ? '&caller=' + encodeURIComponent(filter.caller) : ''}${filter.did ? '&did=' + filter.did : ""}${filter.rate ? '&rate=' + filter.rate : ""}${filter.virtual != null && filter.virtual !== '' ? '&virtual=' + filter.virtual : ''}`);
    }
    static reportGraphic(type, isTrue, filter) {
        return api.get(`/graph_report/graphic?type=${type}&isTrue=${isTrue}${filter.timeStartStart ? '&timeStartStart=' + filter.timeStartStart : ''}${filter.timeEndEnd ? '&timeEndEnd=' + filter.timeEndEnd : ''}${filter.caller ? '&caller=' + encodeURIComponent(filter.caller) : ''}${filter.did ? '&did=' + filter.did : ''}${filter.number ? '&number=' + filter.number : ''}${filter.virtual != null && filter.virtual !== '' ? '&virtual=' + filter.virtual : ''}`);
    }


    //-------CALLCENTER--------//
    static callCenterGet() {
        return api.get(`/call-center/get`);
    }
    static callCenterCreate(form) {
        return api.post(`/call-center/create`, { ...form, urs: Account.getUrsToken() });
    }
    static callCenterDelete(id) {
        return api.delete(`/call-center/delete?id=${id}`, { id, token: Account.getUrsToken() });
    }

    //-------CRMS.AM-------//
    static createCrmsAm(buddy, crmkey) {
        return api.post(`/crmsam/create`, { params: crmkey, sip: buddy, token: Account.getUrsToken() });
    }
    static deleteCrmsAm(id, buddy) {
        return api.post(`/crmsam/delete`, { id, sip:buddy,token: Account.getUrsToken() });
    }
    static getCrmsAm() {
        return api.get(`/crmsam/get`);
    }
    static deleteCrmsAmAll() {
        return api.post(`/crmsam/delete_all`, { token: Account.getUrsToken() });
    }
    static installCrmsAm(code) {
        return api.post(`/crmsam/install`, { params: code, token: Account.getUrsToken() });
    }
   
}


export default Api;
